/**
 * Site-wide hydration of the dynamic processing notice ("wordt morgen /
 * donderdag 2 oktober verwerkt").
 *
 * The notice is rendered server-side into `.js-orderText` placeholders across
 * cached pages (shop/category archive, search, blog sidebar, homepage blocks,
 * single product, ...). Because that HTML is baked into the page cache it goes
 * stale (after 17:00, weekends, out-of-office). Here we overwrite each
 * placeholder with the live value from the uncached `get_datepicker_config`
 * endpoint (Cache-Control: no-store), computed in Europe/Amsterdam.
 *
 * The server-rendered text stays as a no-JS / SEO fallback; we only overwrite it
 * when JS runs, and we re-run on tab-return / bfcache restore (iOS Safari).
 */

const ACTION = 'get_datepicker_config';

let configPromise = null;

function ajaxBase() {
    return (typeof junc_woocommerce_params !== 'undefined' && junc_woocommerce_params.ajax_url)
        ? junc_woocommerce_params.ajax_url
        : '/wp-admin/admin-ajax.php';
}

function lcfirst(str) {
    if (!str) return str;
    return str.charAt(0).toLowerCase() + str.slice(1);
}

function fetchConfig(force) {
    if (configPromise && !force) return configPromise;
    const base = ajaxBase();
    const sep = base.indexOf('?') === -1 ? '?' : '&';
    const url = base + sep + 'action=' + encodeURIComponent(ACTION);
    configPromise = fetch(url, { cache: 'no-store', credentials: 'same-origin' })
        .then((r) => r.json())
        .then((json) => (json && json.data) ? json.data : {})
        .catch(() => ({}));
    return configPromise;
}

function hydrate(data) {
    const variants = (data && data.orderTextVariants) || null;
    if (!variants) return;
    document.querySelectorAll('.js-orderText').forEach((el) => {
        const variant = el.getAttribute('data-order-variant') || 'physical';
        const text = variants[variant];
        if (typeof text !== 'string' || text === '') return; // keep server fallback
        el.innerHTML = el.hasAttribute('data-lcfirst') ? lcfirst(text) : text;
    });
}

function run(force) {
    // No notice on this page -> no request at all.
    if (!document.querySelector('.js-orderText')) return;
    fetchConfig(force).then(hydrate);
}

document.addEventListener('DOMContentLoaded', () => run(false));

// Re-hydrate when returning to a backgrounded tab or when the page is restored
// from the iOS Safari back-forward cache (which does NOT re-run DOMContentLoaded;
// it fires pageshow with persisted=true).
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') run(true);
});
window.addEventListener('pageshow', (e) => {
    if (e && e.persisted) run(true);
});
